<template>
    <v-container class="grey lighten-5" fluid>
        <div>
            <!-- Filters -->
            <ni-filters
            :search="search"
            @search="updateSearch($event)"
            ></ni-filters>

            <v-row>
                <v-col md="6" class="pt-0 caption stats">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn x-small color="primary" tile class="elevation-0" v-on="on">
                                <v-icon class="px-1" small color="white">mdi-sigma</v-icon>{{ new Intl.NumberFormat('en-US').format(stats.total) }}
                            </v-btn>
                        </template>
                        Total Transactions
                    </v-tooltip>
                    
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn x-small color="success" tile class="elevation-0" v-on="on">
                                <v-icon class="px-1" small color="white">mdi-check-circle</v-icon>
                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'AED' }).format(stats.sum) }}
                            </v-btn>
                        </template>
                        Successful Debit
                    </v-tooltip>
                </v-col>
                <v-col align="end" class="pt-0">
                    <v-btn
                        small
                        dark
                        color="primary"
                        class="mb-3 mr-2"
                        @click="refresh();"
                        ><v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn
                        small
                        dark
                        color="primary"
                        class="mb-3"
                        @click="download()"
                        ><v-icon>mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </v-col>
            </v-row>


            <!-- Transactions Table -->
            <v-data-table
                :headers="table.headers"
                :items="table.data"
                :items-per-page="10"
                :loading="table.loading"
                class="elevation-1"
            >
            </v-data-table>
        </div>
    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import NiFilters from '@/components/niPos/Filters.vue';

export default {
    components: {
        'ni-filters': NiFilters,
    },

    data() {
        return {
            table: {
                headers: [
                    { text: 'Date', value: 'processingTime', sortable: true, align: 'left', width: 130 },
                    { text: 'Merchant ID', value: 'merchant_id', sortable: false },
                    { text: 'Chain ID', value: 'chain_id', sortable: false },
                    { text: 'Merchant Name', value: 'merchant_name', sortable: false },
                    { text: 'Location', value: 'location', sortable: false },
                    { text: 'Terminal ID', value: 'terminal_id', sortable: false, align: 'center' },
                    { text: 'Amount', value: 'amount', sortable: false, align: 'center' },
                    { text: 'Currency', value: 'currency', sortable: false, align: 'center' },
                    { text: 'Payment Type', value: 'paymentType', sortable: false, align: 'center' },
                    { text: 'Payment Brand', value: 'paymentBrand', sortable: false, align: 'center' },
                    { text: 'BIN', value: 'bin', sortable: false, align: 'center' },
                    { text: 'Last4Digits', value: 'last4Digits', sortable: false, align: 'center' },
                    { text: 'Commission', value: 'commission', sortable: true, align: 'center' },
                    { text: 'Commission Rate', value: 'commission_rate', sortable: true, align: 'center' },
                    { text: 'VAT Amount', value: 'vat_amount', sortable: false, align: 'center' },
                    { text: 'NET Amount', value: 'net_amount', sortable: false, align: 'center' },
                    { text: 'Card Issuer', value: 'card_issuer', sortable: false, align: 'center' },
                    { text: 'Card Type', value: 'card_type', sortable: false, align: 'center' },
                    { text: 'Card Level', value: 'card_level', sortable: false, align: 'center' },
                    { text: 'BIN Type', value: 'bin_type', sortable: false, align: 'center' },
                    { text: 'Card Country', value: 'card_country', sortable: false, align: 'center' }
                ],
                data: [],
                loading: true,
            },

            stats: {
                total: 0,
                sum: 0,
            },
            
            search: {
                fromDate: moment().startOf('month').format('YYYY-MM-DD'),
                toDate: new Date().toISOString().substr(0, 10)
            },

            filters: {
                fromDate: {
                    modal: null,
                },
                toDate: {
                    modal: null,
                },
                issuers: [],
                merchant_ids: [],
                chain_ids: [],
                merchant_names: [],
                location: [],
                payment_brands: [],
                card_types: [],
                ni_pos_merchants: [],
            },
        }
    },
    beforeMount() {
        this.calcStats();
        this.getLatestTransactionDate();
    },
    methods: {
        masterReq(url, responseType='json', method='post', data={search: this.search}) {
            return axios({
                method: method,
                url: url,
                data: data,
                responseType: responseType,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
        },

        getTransactions() {
            this.masterReq('get-transactions-live-ni-pos').then((response) => {
                this.table.data = response.data;
                this.table.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            });

            this.calcStats();
        },

        calcStats() {
            this.masterReq('get-stats-live-ni-pos').then((response) => {
                this.stats = response.data[0];
                console.log("stats:", this.stats);
            })
            .catch(e => {
                this.errors.push(e)
            });
        },

        download() {
            this.masterReq('download-transactions-live-ni-pos', 'blob').then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'ni-pos-transactions-report.csv');
                document.body.appendChild(link);
                link.click();
            })
            .catch(e => {
                this.errors.push(e)
            });
        },

        getLatestTransactionDate() {
            this.masterReq('get-latest-transaction-date-live-ni-pos').then((response) => {
                this.table.loading = false;

                this.search.fromDate = response.data.fromDate;
                this.search.toDate = response.data.toDate;
                this.table.data = response.data.txs
            })
            .catch(e => {
                this.errors.push(e)
            });
        },

        handleDateFilters() {
            if(this.search.toDate < this.search.fromDate) {
                this.search.fromDate = this.search.toDate;
            }
            this.refresh();
        },

        updateSearch(e) {
            this.search = e;
            this.refresh();
        },

        refresh() {
            console.log("refresh");
            this.table.loading = true;
            this.getTransactions();
        },
    }
}
</script>

<style>
    .v-data-table td {
        font-size: 0.6rem !important;
    }

    .stats {
        display: inline-flex;
        vertical-align: middle;
        align-items: center;
    }
</style>